import { Box, Typography, TextField } from '@mui/material';
import useDebounce from '../../../hooks/useDebounce';
import React, { useState, useEffect } from 'react';
import Iconify from '../../Iconify'
import '../../../css/machines/machineNoteFiltration.css';

const MachineNoteFiltration = ({ handleResetFilters, fetchedNotes, filteredNotesCount, machineNoteFiltration, setMachineNoteFiltration }) => {

    const [search, setSearch] = useState(machineNoteFiltration.search);

    const debouncedSearch = useDebounce(search, 1000);

    useEffect(() => {
        setMachineNoteFiltration((prev) => ({
            ...prev,
            search: debouncedSearch
        }));
    }, [debouncedSearch, setMachineNoteFiltration]);

    const clearFilters = () => {
        setSearch('')
        handleResetFilters()
    }

    return (
            <Box className="machineNoteFiltration_search_display_box">
                    <Box className='machineNoteFiltration_search_box'>
                        <TextField
                            sx={{ width: '100%' }}
                            size="small"
                            value={search}
                            placeholder='Rechercher'
                            onChange={(e) => setSearch(e.target.value)}
                            variant="outlined"
                            InputProps={{
                                startAdornment: <Iconify icon={"bx:bx-search"} className='machineNoteFiltration_search_icon' />,
                                sx: {
                                    backgroundColor: '#fff',
                                    height: '36px',
                                    fontFamily: 'Mulish',
                                    color: '#201E1E',
                                    fontSize: '14px',
                                    fontWeight: 400,
                                },
                            }}
                        />
                        <Typography className='machineNoteFiltration_clearAll' onClick={clearFilters}>Re-initialiser</Typography>
                    </Box>
                    <Typography className='machineNoteFiltration_total_number'>{`${fetchedNotes} / ${filteredNotesCount} résultats`}</Typography>
            </Box>
    )
}

export default MachineNoteFiltration